import { AnimationRefs } from '../../../hooks/use-animation-refs';
import { Viewport } from '../../../hooks/use-viewport';
import { animateStars } from '../../helpers/animate-stars';

export function buildStage3(tl: GSAPTimeline, refs: AnimationRefs, viewport: Viewport) {
  const { vw, vh } = viewport;

  tl.to(
    refs.buttons.action.current,
    {
      scale: vw(0.00468),
      duration: 2,
      backgroundColor: '#FFEAA5',
      boxShadow: '0 0 50px 11px #F5E7BA',
    },
    'stage3'
  )
    .to(
      refs.blobs.pink.current,
      {
        width: vw(0.9),
        height: vh(0.29),
        x: vw(0.15),
        y: vh(0.1),
        duration: 2,
      },
      'stage3'
    )
    .to(
      refs.blobs.cyan.current,
      {
        width: vw(0.96),
        height: vh(0.33),
        x: vw(-0.1),
        y: vh(0.36),
        duration: 2,
      },
      'stage3'
    );

  animateStars({
    tl,
    stars: refs.stars,
    label: 'stage3',
    animations: [
      { x: vw(0.15), y: vh(-0.4), scale: 1.2, duration: 2 },
      { x: vw(-0.28), y: vh(-0.473), scale: 1.2, duration: 2 },
      { x: vw(0.427), y: vh(-0.303), scale: 1.2, duration: 2 },
      { x: vw(-0.385), y: vh(-0.226), scale: 1.2, duration: 2 },
      { x: vw(-0.072), y: vh(-0.175), scale: 1.2, duration: 2 },
      { x: vw(0.24), y: vh(-0.17), scale: 1.2, duration: 2 },
    ],
  });
}
